import { type FC, useState, type ComponentProps } from "react";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import { SpScoutRemainingCountDetail } from "./uiParts/SpScoutRemainingCountDetail";

import * as styles from "./styles.css";

type Props = ComponentProps<typeof SpScoutRemainingCountDetail>;
export const SpScoutRemainingCountDetailWrapperModal: FC<Props> = ({ ...props }) => {
  const [isShow, setIsShow] = useState(false);
  const handleClickToggleModal = () => setIsShow(!isShow);
  return (
    <>
      <button type="button" onClick={handleClickToggleModal} className={styles.button}>
        {/* 例外的に、sprinklesにはない、既存の画面に合わせた色を使用する。 */}
        <Icon name="calendar-check" fontSize="18px" color="#5a5a6a" />
        <span className={styles.buttonText}>詳細・期限</span>
      </button>
      <Modal
        isShow={isShow}
        headerTitleStyle="white"
        headerTitle="各種スカウトの詳細・有効期限"
        footerContentStyle="none"
        spAppearanceType="bottom"
        onClose={handleClickToggleModal}
      >
        <SpScoutRemainingCountDetail {...props} />
      </Modal>
    </>
  );
};
